import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import debounce from 'debounce-promise';
import { SearchOutlined, CalendarOutlined, LoadingOutlined, CloseCircleFilled } from '@ant-design/icons-vue';
export default {
  components: {
    CloseCircleFilled: CloseCircleFilled,
    LoadingOutlined: LoadingOutlined,
    SearchOutlined: SearchOutlined
  },
  data: function data() {
    return {
      query: '',
      date: null,
      dateRange: null,
      dateType: 'date',
      loading: false,
      inputHover: false,
      controller: new AbortController()
    };
  },
  computed: {
    datePickerIconC: function datePickerIconC() {
      return this.loading && !this.activeDateIsEmpty ? LoadingOutlined : CalendarOutlined;
    },
    reqOptions: function reqOptions() {
      var options = {
        params: {
          chatId: document.querySelector('.chat-result-content').dataset.id
        },
        signal: this.controller.signal
      };

      if (this.query.length > 2) {
        options.params.query = this.query;
      }

      if (this.dateType === 'range') {
        if (!this.dateRange) {
          return options;
        }

        if (this.dateRange[0]) {
          options.params.dateFrom = this.dateRange[0].format('YYYY-MM-DD');
        }

        if (this.dateRange[1]) {
          options.params.dateTo = this.dateRange[1].format('YYYY-MM-DD');
        }
      } else {
        if (this.date) {
          options.params.date = this.date.format('YYYY-MM-DD');
        }
      }

      return options;
    },
    activeDateIsEmpty: function activeDateIsEmpty() {
      if (this.dateType === 'range') {
        return !this.dateRange;
      } else {
        return !this.date;
      }
    }
  },
  watch: {
    dateType: function dateType(newVal) {
      if (newVal === 'range') {
        if (this.date) {
          this.dateRange = [this.date, null];
        }
      } else {
        if (this.dateRange instanceof Array) {
          this.date = this.dateRange[0];
        }
      }

      if (!this.activeDateIsEmpty) {
        this.search();
      }
    }
  },
  methods: {
    search: function search() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, chatsListWrapperEl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                chatsListWrapperEl = document.querySelector('#chats-container');

                if (!(_this.query.length <= 2 && _this.activeDateIsEmpty)) {
                  _context.next = 4;
                  break;
                }

                if (searchIsActive) {
                  _this.disableSearchPanel();
                }

                return _context.abrupt("return");

              case 4:
                if (_this.loading) {
                  _this.controller.abort();

                  _this.controller = new AbortController();
                }

                _context.next = 7;
                return _this.fetchMessages();

              case 7:
                res = _context.sent;

                if (res) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                if (res.data.messages.length) {
                  _context.next = 13;
                  break;
                }

                _this.disableSearchPanel();

                return _context.abrupt("return", _message.info('Ничего не найдено'));

              case 13:
                _this.enableSearchPanel();

                chatsListWrapperEl.insertAdjacentHTML('afterbegin', $.render.searchBlockTmpl({
                  searchItemsChats: [],
                  searchItemsMessages: res.data.messages,
                  userId: null,
                  isDialogSearch: true
                }));

                _this.addMessageJumpEvents();

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    fetchMessages: debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = true;
              _context2.prev = 1;
              _context2.next = 4;
              return axios.get('/chat/dialogSearch', this.reqOptions);

            case 4:
              res = _context2.sent;
              _context2.next = 9;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

            case 9:
              this.loading = false;
              return _context2.abrupt("return", res);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 7]]);
    })), 300),
    enableSearchPanel: function enableSearchPanel() {
      var chatsListEl = document.querySelector('.original-chat-list-block');

      if (chatsListEl) {
        chatsListEl.hidden = true;
      }

      this.removeSearchResults();
      searchIsActive = true;
    },
    disableSearchPanel: function disableSearchPanel() {
      var chatsListEl = document.querySelector('.original-chat-list-block');

      if (chatsListEl) {
        chatsListEl.hidden = false;
      }

      this.removeSearchResults();
      searchIsActive = false;
    },
    removeSearchResults: function removeSearchResults() {
      var searchResultEl = document.querySelector('.search-results-list');

      if (searchResultEl) {
        searchResultEl.remove();
      }
    },
    addMessageJumpEvents: function addMessageJumpEvents() {
      var resultsEl = document.querySelector('.search-results-list .list-group');

      if (!resultsEl) {
        return;
      } // Add event of jumping to a message


      resultsEl.addEventListener('click', function (e) {
        var el, activeChatLink;

        if (loadingMessages) {
          $.growl('Сообщения уже загружаются, подождите...');
          return;
        }

        el = e.target;

        if (e.target.nodeName != 'A') {
          el = el.parentNode;
        }

        activeChatLink = document.querySelector('#chats-container .dialog-link.active');

        if (activeChatLink) {
          activeChatLink.classList.remove('active');
        }

        el.classList.add('active');
        jumpToMessage($(el));
      });
    }
  }
};